document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".cs-book-slider-tabs .book-tab-btn")
    .forEach((btn) => {
      btn.addEventListener("click", () => {
        const tab = btn.getAttribute("data-tab");
        const wrapper = btn.closest(".cs-book-slider-tabs");

        wrapper
          .querySelectorAll(".book-tab-btn")
          .forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        wrapper.querySelectorAll(".book-tab-panel").forEach((panel) => {
          panel.classList.remove("active");
          if (panel.getAttribute("data-content") === tab) {
            panel.classList.add("active");
          }
        });
      });
    });
});
